import { useBeam } from '@randajan/bifrost/client/react';
import React, { useEffect } from 'react';
import { Block } from "@randajan/jet-react/dom/block";

import "./EventDetail.scss";
import { eventBeam } from '../../../assets/beams/eventBeam';
import { eventSignBeam } from '../../../assets/beams/eventSignBeam';
import { Locale } from '../../../assets/Locale';
import { EventUsers } from '../parts/EventUsers/EventUsers';
import { buildEventDetail } from './eventDetailData';
import { EventDetailFacts } from './EventDetailFacts/EventDetailFacts';
import { EventDetailHero } from './EventDetailHero/EventDetailHero';
import { EventDetailSummary } from './EventDetailSummary/EventDetailSummary';
import { page } from '../../../assets/bases/page';



export const EventDetail = (props)=>{
    const { eventId } = props;
    const say = Locale.use();

    const { data:event } = useBeam(eventBeam, [eventId]);
    const { data:eventSign } = useBeam(eventSignBeam, [eventId]);

    if (!event) { return null; }

    const detail = buildEventDetail(event, eventSign, say);
    

    return (
        <Block tagName="section" className="EventDetail wall -gaps">
            <EventDetailHero event={event} detail={detail}/>
            <section className="EventDetail-body">
                <EventDetailFacts event={event} detail={detail}/>
                <EventDetailSummary event={event} detail={detail}/>
                <section className="EventDetail-users wall -form">
                    <EventUsers eventId={eventId}/>
                </section>
            </section>
        </Block>
    )
}

